/* ==========================================================================
   1. DATA & STATE MANAGEMENT
   ========================================================================== */
const GIFT_VARIANTS = {
  PATCH: 45281289568435,  // GIFT - Morale Patch (PVC)
  TSHIRT: 45281297498291  // GIFT - Chest Rig Tee (L)
};

const urlParams = new URLSearchParams(window.location.search);
const paramBoxes = parseInt(urlParams.get('boxes')) || 0; 

const qtyMap = new Map();
let targetQty = paramBoxes > 0 ? paramBoxes : 1; 
let isSub = true; // Permanently set to true

/* Format currency helper */
const formatMoney = (amount) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(amount / 100);
};

/* ==========================================================================
   2. CAROUSEL LOGIC (Desktop Only)
   ========================================================================== */
let currentImgIndex = 0;
const slides = document.querySelectorAll('.c-img');
const thumbs = document.querySelectorAll('.thumb');

window.changeSlide = function(step) {
    let newIndex = currentImgIndex + step;
    if (newIndex >= slides.length) newIndex = 0;
    if (newIndex < 0) newIndex = slides.length - 1;
    window.goToSlide(newIndex);
};

window.goToSlide = function(index) {
    if (!slides.length) return;
    currentImgIndex = index;
    slides.forEach(s => s.classList.remove('active'));
    slides[index].classList.add('active');
    thumbs.forEach(t => t.classList.remove('active'));
    if(thumbs[index]) {
        thumbs[index].classList.add('active');
        thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
};

/* ==========================================================================
   3. REAL REVIEW INJECTOR
   ========================================================================== */
function injectRealReview() {
    const reviewCard = document.getElementById('featured-review-card');
    if (!reviewCard) return;

    const rName = document.getElementById('r-name');
    const rTitle = document.getElementById('r-title');
    const rBody = document.getElementById('r-body');
    const rAvatarBox = document.getElementById('r-avatar-box');

    if (rAvatarBox) {
        rAvatarBox.style.backgroundColor = '#3d594f';
        rAvatarBox.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0491/5645/6601/files/Tactical_Snacks_R5-01.png?v=1770039912" id="r-avatar-icon" style="width:auto; object-fit:contain;">`;
    }
}

/* ==========================================================================
   4. GIFT UNLOCK LOGIC
   ========================================================================== */
function updateGifts(qty, isOTP) {
    ['gift-patch', 'gift-shipping', 'gift-apparel'].forEach(id => {
        const el = document.getElementById(id);
        if(el) { el.classList.add('is-locked'); el.classList.remove('is-unlocked'); }
    });
    if (isOTP) return; 
    if (qty >= 1) document.getElementById('gift-patch')?.classList.replace('is-locked', 'is-unlocked');
    if (qty >= 3) document.getElementById('gift-shipping')?.classList.replace('is-locked', 'is-unlocked');
    if (qty >= 6) document.getElementById('gift-apparel')?.classList.replace('is-locked', 'is-unlocked');
}

/* ==========================================================================
   5. MAIN DOM INITIALIZATION & BUILDER LOGIC
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function() {
  const ns = 'trwidget';
  const root = document.querySelector('.ai-bundle-' + ns) || document.querySelector('.ai-bundle-trwidget');

  // Init Carousel (Desktop Only)
  window.goToSlide(0);
  injectRealReview();

  // Init Date
  const dateEl = document.getElementById('dynamic-offer-date');
  if(dateEl) {
      const d = new Date();
      const suffix = (day) => { if(day>3&&day<21)return'th';switch(day%10){case 1:return"st";case 2:return"nd";case 3:return"rd";default:return"th";}};
      dateEl.innerText = d.toLocaleDateString('en-US', {month:'short', day:'numeric'}) + suffix(d.getDate());
  }

  // Init Timer
  const timerBox = document.getElementById('valentine-timer');
  if (timerBox) {
    let timeLeft = 43200; // 12 hours
    setInterval(() => {
        timeLeft--; if(timeLeft < 0) timeLeft = 43200;
        const h = Math.floor(timeLeft / 3600).toString().padStart(2,'0');
        const m = Math.floor((timeLeft % 3600) / 60).toString().padStart(2,'0');
        const s = (timeLeft % 60).toString().padStart(2,'0');
        const elH = document.getElementById('vd-hrs');
        const elM = document.getElementById('vd-min');
        const elS = document.getElementById('vd-sec');
        if(elH) elH.innerText = h;
        if(elM) elM.innerText = m;
        if(elS) elS.innerText = s;
    }, 1000);
  }

  if (!root) return; // Exit if no builder found

  // Default Unit Price Calculation
  let defaultUnitPrice = 0;
  const firstProduct = root.querySelector('.ai-bundle__item-'+ns);
  if(firstProduct) {
     defaultUnitPrice = parseInt(firstProduct.getAttribute('data-price')) || 0;
  }

  // UI Selectors
  const fill = root.querySelector('.ai-bundle__fill-' + ns);
  const ticks = root.querySelectorAll('.ai-bundle__tick-' + ns);
  const cta = root.querySelector('.ai-bundle__cta-' + ns);
  const tierLabels = root.querySelectorAll('.ai-bundle__labels-trwidget span');
  const stickyBtn = document.getElementById('sticky-proxy-btn');
  const stickyBar = document.getElementById('javvy-sticky-atc');
  
  const sbTextDisplay = document.getElementById('sb-text-display');


// Function to update the top selection banner
  function updateSelectionBanner(qty, isCompletelySoldOut = false) {
      if (sbTextDisplay) {
          if (isCompletelySoldOut) {
              sbTextDisplay.innerHTML = `<strong>ALL ITEMS SOLD OUT</strong>`;
          } else {
              sbTextDisplay.innerHTML = `Select at least <strong>${qty}</strong> box${qty > 1 ? 'es' : ''}`;
          }
      }
  }

  // Initialize Selection Banner Number
  updateSelectionBanner(targetQty);

  function render() {
    let totalBase = 0; 
    let totalQty = 0;      
    
    root.querySelectorAll('.ai-bundle__item-' + ns).forEach(row => {
      const vid = row.getAttribute('data-variant-id');
      const price = parseInt(row.getAttribute('data-price')) || 0;
      let q = qtyMap.get(vid) || 0;
      
      if (q > 0) {
        totalBase += price * q; 
        totalQty += q;
        row.setAttribute('data-has-qty', 'true');
        const qtyNum = row.querySelector('.ai-bundle__qtynum-' + ns);
        if(qtyNum) qtyNum.textContent = q;
      } else {
        row.setAttribute('data-has-qty', 'false');
      }
    });

    // Auto-upgrade targetQty if user adds more items manually than their tier
    if (totalQty >= 6) targetQty = Math.max(targetQty, 6);
    else if (totalQty >= 3) targetQty = Math.max(targetQty, 3);
    else if (totalQty >= 1) targetQty = Math.max(targetQty, 1);

    const currentSelection = Math.max(targetQty, totalQty);

    // Price Calculations (Volume Multipliers)
    let volumeMultiplier = 1.0;
    if(totalQty >= 6) volumeMultiplier = 0.76;
    else if(totalQty >= 3) volumeMultiplier = 0.86;

    let baseAmountForCalc = (totalQty > 0) ? totalBase : defaultUnitPrice;

    let discountedOneTimeTotal = baseAmountForCalc * volumeMultiplier;
    // Subscription gets extra 15% off
    let discountedSubTotal = discountedOneTimeTotal * 0.85; 
    
    let finalTotal = isSub ? discountedSubTotal : discountedOneTimeTotal;
    let ctaStrikeTotal = baseAmountForCalc; 

    // Keep Top Banner Sync'd
    updateSelectionBanner(targetQty);

    ticks.forEach(t => t.classList.remove('is-active'));
    if (targetQty >= 1 && ticks[0]) ticks[0].classList.add('is-active');
    if (targetQty >= 3 && ticks[1]) ticks[1].classList.add('is-active');
    if (targetQty >= 6 && ticks[2]) ticks[2].classList.add('is-active');

    // Dynamic Highlighting of Prices and Discounts
    const tierPrices = root.querySelectorAll('.ai-bundle__tier-price');
    const tierDiscounts = root.querySelectorAll('.tier-discount-txt');
    if(tierPrices.length) tierPrices.forEach(tp => tp.classList.remove('is-active'));
    if(tierDiscounts.length) tierDiscounts.forEach(td => td.classList.remove('is-active'));

    if (targetQty >= 1 && tierPrices[0]) { tierPrices[0].classList.add('is-active'); if(tierDiscounts[0]) tierDiscounts[0].classList.add('is-active'); }
    if (targetQty >= 3 && tierPrices[1]) { tierPrices[1].classList.add('is-active'); if(tierDiscounts[1]) tierDiscounts[1].classList.add('is-active'); }
    if (targetQty >= 6 && tierPrices[2]) { tierPrices[2].classList.add('is-active'); if(tierDiscounts[2]) tierDiscounts[2].classList.add('is-active'); }

    if (fill) {
        let visualPct = 0;
        if (targetQty === 1) visualPct = 0;
        else if (targetQty === 3) visualPct = (totalQty / 3) * 50;
        else if (targetQty === 6) visualPct = (totalQty / 6) * 100;
        fill.style.width = Math.min(visualPct, 100) + '%';
    }

    
    updateGifts(currentSelection, !isSub);

    // Check how many items are actually available
    const availableItems = root.querySelectorAll('.ai-bundle__item-trwidget:not(.is-sold-out)').length;
    const isCompletelySoldOut = availableItems === 0;

    // Keep Top Banner Sync'd with sold out status
    updateSelectionBanner(targetQty, isCompletelySoldOut); 

    const remaining = targetQty - totalQty;
    if(cta) {
        if (isCompletelySoldOut) {
          cta.disabled = true;
          cta.innerHTML = `ALL ITEMS SOLD OUT`;
        } else if (remaining > 0) {
          cta.disabled = true;
          cta.innerHTML = `Select at least ${targetQty} box${targetQty > 1 ? 'es' : ''}`;
        } else {
          cta.disabled = false;
          let showStrike = isSub || totalQty >= 3;
          let priceHtml = showStrike ? `<span class="ai-bundle__price-old">${formatMoney(ctaStrikeTotal)}</span><span class="ai-bundle__price-new">${formatMoney(finalTotal)}</span>` : `<span class="ai-bundle__price-new">${formatMoney(finalTotal)}</span>`;
          cta.innerHTML = `Checkout Now <span class="ai-bundle__price-pill">${priceHtml}</span><div class="ai-bundle__cta-loader"></div>`;
        }
    }

    if(stickyBtn && cta) {
      stickyBtn.innerHTML = cta.innerHTML;
      stickyBtn.disabled = cta.disabled;
    }
  } // END OF RENDER FUNCTION

  function setTargetTier(n) {
    targetQty = n;
    let currentTotal = 0;
    qtyMap.forEach(v => currentTotal += v);
    if(currentTotal > targetQty) qtyMap.clear();
    render();
  }

  ticks.forEach(tick => tick.addEventListener('click', () => setTargetTier(parseInt(tick.dataset.step))));
  if(tierLabels.length === 3) {
      tierLabels[0].addEventListener('click', () => setTargetTier(1));
      tierLabels[1].addEventListener('click', () => setTargetTier(3));
      tierLabels[2].addEventListener('click', () => setTargetTier(6));
  }
root.querySelectorAll('.ai-bundle__item-' + ns).forEach(row => {
    const vid = row.getAttribute('data-variant-id');
    const addBtn = row.querySelector('.ai-bundle__add-' + ns);
    const decBtn = row.querySelector('[data-action="decrease"]');
    const incBtn = row.querySelector('[data-action="increase"]');
    
    // Limits removed so user can add infinitely past targetQty
    // Only add click if the button exists AND is not disabled
    if(addBtn && !addBtn.disabled) addBtn.addEventListener('click', () => { 
        qtyMap.set(vid, 1); render(); 
    });
    if(incBtn) incBtn.addEventListener('click', () => { 
        let q = qtyMap.get(vid) || 0; qtyMap.set(vid, q + 1); render(); 
    });
    if(decBtn) decBtn.addEventListener('click', () => { 
        let q = qtyMap.get(vid) || 0; if(q > 0) qtyMap.set(vid, q - 1); render(); 
    });
  });

  const handleAddToCart = async () => {
    if (!cta || cta.disabled || cta.classList.contains('is-loading')) return;
    cta.classList.add('is-loading');
    if(stickyBtn) stickyBtn.classList.add('is-loading');

    const items = []; 
    qtyMap.forEach((qty, id) => {
      if (qty > 0) {
        const item = { id: Number(id), quantity: Number(qty) };
        const row = root.querySelector(`[data-variant-id="${id}"]`);
        if (isSub && row && row.dataset.sellingPlanId) item.selling_plan = Number(row.dataset.sellingPlanId);
        items.push(item);
      }
    });

    let currentSelection = 0;
    qtyMap.forEach(v => currentSelection += v);

    if (isSub) {
      if (currentSelection >= 1) items.push({ id: Number(GIFT_VARIANTS.PATCH), quantity: 1, properties: { '_reward': 'Sub-Tier-1' } });
      if (currentSelection >= 6) items.push({ id: Number(GIFT_VARIANTS.TSHIRT), quantity: 1, properties: { '_reward': 'Sub-Tier-6' } });
    } else {
      if (currentSelection >= 6) items.push({ id: Number(GIFT_VARIANTS.PATCH), quantity: 1, properties: { '_reward': 'OTP-Tier-6' } });
    }

    try {
      const res = await fetch('/cart/add.js', { 
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' }, 
        body: JSON.stringify({ items }) 
      });

      if (res.ok) {
        window.location.href = '/checkout';
      } else {
        cta.classList.remove('is-loading');
        if(stickyBtn) stickyBtn.classList.remove('is-loading');
      }
    } catch(err) {
      cta.classList.remove('is-loading');
      if(stickyBtn) stickyBtn.classList.remove('is-loading');
    }
  };

  if(cta) cta.addEventListener('click', handleAddToCart);
  if(stickyBtn) stickyBtn.addEventListener('click', handleAddToCart);

  // Sticky Bar Observer
  if (stickyBar && cta) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) stickyBar.classList.add('is-visible');
        else stickyBar.classList.remove('is-visible');
      });
    }, { threshold: 0 });
    observer.observe(cta);
  }

  render();
});